import { Notification } from "./Notification"

export interface PlatformLoadMetricCounts {
  current: number
  max: number
}

export interface NotificationPlatformLoadMetricsContent {
  projectName: string
  teamName: string
  sprintUrl: string
  incidents: PlatformLoadMetricCounts
  reliability: PlatformLoadMetricCounts
  security: PlatformLoadMetricCounts
  performance: PlatformLoadMetricCounts
}

/**
 * Represents the platform-load payload serialized by PlatformLoadMetricsExceededEmailModel.
 */
export class NotificationPlatformLoadMetrics extends Notification {
  get content(): NotificationPlatformLoadMetricsContent {
    return super.content as NotificationPlatformLoadMetricsContent
  }
}
